<template>
  <div class="capitalDetail">
    <!-- 头部 -->
    <header class="header">
      <div class="header-content">
        <div class="left" @click="changego">
          <van-icon name="arrow-left" color="#fff" size="20px" />
        </div>
        <div class="title">充值记录</div>
        <div class="right">
          <span class="filter-text">筛选</span>
          <img class="filter-icon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAA4BJREFUWEftlk9oHVUUxr8zk4c8BFsQkpl3z7MJNIbaggrRoiulK9GuinaTam2LrkqKgkK6UAQVBcXoSm3V/tko3am4abUr/waKkFo0gsS5981LwdAKTTB5M6dcvS/ENHkz0/eqWby7nHvO9/3uuefeO4R1Pmid86EL2O4OdSvY8QrGcfxQkiQnieiWdsWL5IvIn77vj4Rh+MXyvGu22Bjzmog8V0S8U7FE9LpS6vmWgHEc9ydJ8hOAsgvUAC51CmKFzkYA7L7NNxqNrf39/b+1BLSTxpgXReQFF/g5Mz9yIwC11p8BeNhqE9FLSqmm55Ldqqc4iqIyEV0AsMlF7mRmK9axobW2i/7UwU0T0R2VSmVupcGa10ytVtuVpukpl/Dr/Pz8tsHBwb86QTg1NXVTuVyeBLDZ6vm+/2gYhk2vf1m0vAeNMadFZIfLOMzMr3QCUGs9BuBlp/UlMzc9rpFvCTg9Pb3V9/1zAEoArhDRFqVU1A6kMaYqIrZ9bgbQ8H3/rjAMz6+lmfmSaK3fAjDqBD5h5t3tAGqtPwbwmNMYZ+ZDrfQyAWdnZzfMzc39AqCXiMRuOTN/dT2QWusHieiMiBARXVxYWBgaGBhoeYVlArprZ7+IHHFQk0qpu4moUQRSRHqMMbZdtrmTe0ApdTRLIxegXbEx5jsA91hBz/MOVSqV8Szx5fO1Wm00TVPbLnb8oJTabnckSyMXoBWJomi753lfi4hnX5aenp6hIAguZhnY+Xq93ttoNH4GsJGIUt/37w+CwC44c+QGtEpa6w8B7HVb9IFSan+mwz8v01ER2ediP2LmJ/Pk/e2TN9DGzczM9C0uLtpKbABgK3FfGIbft9KI4/jeJEm+sZ0B4HKpVBrq6+ubyetbCNBV8RkAb+TpJdsOxphvm70L4FlmfjMvXOEK2oSJiYlSEAQ/AtjitvodAPYaWm3cLiIH3cSFer1+5/Dw8OINBXRVfArAu0WMADzNzO8VzCnWg01xrfXjAI4VNHuCmY8XzOkI4Jjnee+vZpwkyQEietXN/T+AIjJarVbfXg0wiqKDRNSc6wIuFWl5D3YrWPRUuWtm6RSv+woCiAH8scZCbwUQ/uenOIqiESI6UaT6IrKnWq2eLJJzXU+dTTLG3AbgLIBqHsM0TSPP8x5QSv2eJ355TOGfhaIG7cZ3AbsVbLcC7eav+x68CtWBZTh4OHoFAAAAAElFTkSuQmCC" alt="筛选" />
        </div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="--END--"
          @load="onLoad"
        >
          <!-- 空数据 -->
          <div class="empty-state" v-if="list.length === 0">
            <img src="@/assets/image/czbg.png" class="empty-image" alt=""/>
            <p class="empty-tip">没有任何记录</p>
            <p class="empty-subtitle">和往常一样，这里什么都没</p>
          </div>
          
          <!-- 交易记录列表 -->
          <div class="record-list" v-else>
            <div 
              class="record-item" 
              v-for="(item, index) in list" 
              :key="index"
            >
              <div class="record-main">
                <div class="record-left">
                  <div class="record-type">
                    <span>预购</span>
                  </div>
                </div>
                <div class="record-right">
                  <div class="record-amount">{{ item.quantity }}</div>
                </div>
              </div>
              <div class="record-bottom">
                <div class="record-time">{{ timeStr(item.createtime) }}</div>
                <div class="record-status">
                  <span class="status-btn success">成功</span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- 弹出层 -->
    <van-popup
      v-model:show="show"
      position="right"
      :style="{ width: '5.88rem', height: '100%' }"
    >
      <div class="drawer-content is-open">
        <div class="my-drawer-content">
          <div>
            <p class="title">{{$t('shijian')}}</p>
            <ul class="opt-time">
              <li @click="(showTime = !showTime), (showTimeType = 0)">
                {{ begin_date ? begin_date :$t('upshijian') }}
              </li>
              <li @click="(showTime = !showTime), (showTimeType = 1)">
                {{ end_date ? end_date : $t('downshijian') }}
              </li>
            </ul>
          </div>
          <div>
            <p class="title">状态</p>
            <ul class="opt-time">
              <template v-for="(item, index) in statueList" :key="index">
                <li
                  style="color: #fff"
                  :class="index == statueActive ? 'active' : ''"
                  @click="statueActive = index"
                >
                  {{ item }}
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <div class="my-drawer-btns">
        <van-button class="bg-fff" @click="Reset">{{$t('chongzhi')}}</van-button>
        <van-button class="bg-red" @click="BtnOk">{{$t('queren')}}</van-button>
      </div>
    </van-popup>
    <!-- 时间选择 -->
    <van-popup
      v-model:show="showTime"
      @click="showTime = false"
      :style="{ width: '100%' }"
      position="bottom"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :title="showGourp"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="changeTime"
      />
    </van-popup>
  </div>
</template>
<script>
import userApi from "@/api/user";
import time from "@/utils/time";
export default {
  name: "CapitalDetail",
  components: {},
  data() {
    return {
      show: false,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      statueList: ["全部",  this.$t('CapActive.chongzhi'),  this.$t('CapActive.tixian'),  this.$t('CapActive.goumai'), this.$t('CapActive.yingli'),  this.$t('CapActive.zengsong')],
      statueActive: 0,
      showTime: false,
      minDate: new Date(2018, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      begin_date: "",
      end_date: "",
    };
  },

  methods: {
    timeStr(items) {
      return time.formatDate(items * 1000);
    },
    timeStrtow(items) {
      return time.formatDatetow(items * 1000);
    },
    formatDate(date) {
      let yy = date.getFullYear();
      let mm = date.getMonth() + 1;
      mm = mm.toString();
      let dd = date.getDate().toString();
      return yy + "-" + mm.padStart(2, 0) + "-" + dd.padStart(2, 0);
    },
    changeTime(value) {
      console.log(this.formatDate(value));
      if (this.showTimeType == 0) {
        this.begin_date = this.formatDate(value);
      } else {
        this.end_date = this.formatDate(value);
      }
    },
    Reset() {
      this.statueActive = 0;
      this.begin_date = "";
      this.end_date = "";
    },
    BtnOk() {
      this.show = false;
      this.$toast.loading({
        message: this.$t('jiazaizhong'),
        duration: 0,
        forbidClick: true,
      });
      // 使用新的接口 /api/user/transactionDetails 并传递 type=0
      // 后端已修改为不传时间默认查询所有时间
      userApi
        .transactionDetails(undefined, undefined, 0)
        .then((data) => {
          if (data.data && data.data.length) {
            this.list = data.data;
          } else {
            this.list = []
            this.$toast(this.$t('Tips.zanwu'));
          }
          this.loading = false;
          this.finished = true;
          this.$toast.clear();
        })
        .catch((error) => {
          console.error('API调用失败:', error);
          this.list = [];
          this.loading = false;
          this.finished = true;
          this.$toast.clear();
        });
    },
    onRefresh() {
      this.refreshing = false;
      this.finished = false;
      this.loading = true;
      this.BtnOk();
    },
    changego() {
      this.$router.go(-1);
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
        this.BtnOk();
      }
    },
  },
  mounted() {
    this.onRefresh();
  },
};
</script>
<style lang="less" scoped>
.capitalDetail {
  width: 100%;
  height: 100vh;
  background: #050925;
  display: flex;
  flex-direction: column;
}

/* 头部样式 */
.header {
  background: #161936;
  position: relative;
  z-index: 100;
  flex-shrink: 0;
}

.header-content {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.header .left,
.header .right {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.header .left {
  justify-content: flex-start;
}

.header .right {
  justify-content: flex-end;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  flex-shrink: 0;
}

.filter-text {
  color: #fff;
  font-size: 14px;
}

.filter-icon {
  width: 25px;
  height: 25px;
}

.header .title {
  flex: 1;
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
}

/* 内容区域 */
.content {
  flex: 1;
  overflow-y: auto;
  background: #050925;
  padding: 0 16px;
}

/* 记录列表 */
.record-list {
  // padding: 16px 0;
}

.record-item {
  background: transparent;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.record-item:last-child {
  border-bottom: none;
}

.record-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.record-left {
  flex: 1;
  text-align: left;
}

.record-type {
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
}

.record-right {
  text-align: right;
}

.record-amount {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}

.record-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.record-time {
  color: #fff;
  font-size: 16px;
  text-align: left;
}

.record-status {
  text-align: right;
}

.status-btn {
  padding: 3px 3px;
  // border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
}

.status-btn.success {
  background: transparent;
  border: 1px solid #4b957c;
  color: #4b957c;
}

.status-btn.pending {
  background: #ffbb33;
  color: #fff;
}

.status-btn.failed {
  background: #ff4444;
  color: #fff;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #8a8fa3;
}

.empty-image {
  width: 58%;
  display: block;
  margin: 0 auto 20px auto;
}

.empty-tip {
  font-size: 18px;
  // margin-bottom: 10px;
  color: #9c9497;
}

.empty-subtitle {
  font-size: 14px;
  color: #9c9497;
  margin: 0;
}

.settingwarp {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.slide-btn {
  padding: 0.24rem;
}
.bg-icon-filtrate {
  width: 0.4rem;
  height: 0.4rem;
  background-image: url(../assets/image/shoudian.png);
}
.bg-icon {
  width: 0.5rem;
  height: 0.5rem;
  margin-left: 0.1rem;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.right {
  right: 0.3rem !important;
}
.mescroll {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  flex: 1;
}
.capital-list {
  padding: 0.2rem;
}
.mescroll-empty {
  width: 100%;
  padding-top: 20px;
  text-align: center;
}
.drawer-content {
  z-index: 1;
  position: absolute;
  top: 0.88rem;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: #374c7c;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1);
  visibility: hidden;
  box-shadow: 0 8px 10px -5px rgb(0 0 0 / 20%), 0 16px 24px 2px rgb(0 0 0 / 14%),
    0 6px 30px 5px rgb(0 0 0 / 12%);
}
.drawer-content.is-open {
  visibility: visible;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.my-drawer-content {
  padding: 0.5rem;
  padding-bottom: 0.72rem;
  max-height: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  text-align: left;
  ul {
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    li {
      width: 47%;
      text-align: center;
      margin-bottom: 0.3rem;
      background-color: #5078b2;
      border-radius: 6px;
      padding: 6px 0;
      font-size: 0.3rem;
      border: 1px solid #5078b2;
    }
  }
}
.title {
  margin-bottom: 0.3rem;
  font-size: 0.4rem;
}
.opt-time {
  color: #bfbfbf;
}
.active {
  border: 1px solid #fe5050 !important;
  color: #fe5050 !important;
}
.my-drawer-btns {
  position: absolute;
  width: 100%;
  bottom: 0;
  z-index: 1;
}
.bg-red {
  width: 50%;
  color: #fff;
  background-color: #7d58c6;
  border: 1px solid #7d58c6;
}
.bg-fff {
  color: #fff;
  width: 50%;
  background: rgb(191, 191, 191);
  border-color: rgb(191, 191, 191);
}
.capital-list-item:first-child {
  margin-top: 0;
}
.capital-list-item {
  background-color: #1a243f;
  margin-top: 0.4rem;
  border-radius: 3px;
  padding: 0.3rem 0.2rem;
  text-align: left;
}
.capital-list-item > div {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.35rem;
}
.time {
  height: 0.6rem;
  line-height: 0.6rem;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  background-color: #30385d;
  color: #fff;
  margin-left: -0.2rem;
  padding: 0 0.16rem;
  display: inline-block;
}
.capital-list-item > div span:last-child {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: right;
}
.capital-list-item > div span:first-child {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.item-middle {
  padding: 0.2rem 0;
}
.item-bottom {
}
</style>